























































































































import Hammer from 'hammerjs'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'

import Breadcrumb from '../components/Breadcrumb.vue'
import OurProducts from '../components/OurProducts/OurProducts.vue'
import LayoutHeader from '../components/Sidebar/LayoutHeader.vue'
import SidebarHeader from '../components/Sidebar/SidebarHeader.vue'
import SidebarMenu from '../components/Sidebar/SidebarMenu.vue'
import PanelLayoutMixin from '../mixins/PanelLayoutMixin'

Vue.directive("swipe", {
  bind(el, action) {
    if (typeof action.value === "function") {
      const hammer = new Hammer(el);

      hammer.on("swipe", action.value);
    }
  }
});

@Component({
  components: {
    SidebarHeader,
    LayoutHeader,
    Breadcrumb,
    SidebarMenu,
    OurProducts
  },
})
export default class Panel extends Mixins<PanelLayoutMixin>(PanelLayoutMixin) {
  get showProducts():boolean | undefined {
    return this.$store.state.AdminTemplate.applicationConfig.footer?.ourProducts?.visible ?? true
  }
}
